<template>
    <transition name="fade">
        <div class="nav" v-if="showFloat">
            <img class="logo" src="../assets/logo.png" alt="cue-logo-bw" />
			<div class="burger" :class="{animate: toggler}" @click="toggleMenu"></div>
            <div class="list-wrap">
                <a v-scroll-to="`#home`" href="#home">Home</a>
                <a v-scroll-to="`#about`" href="#about">About</a>
                <a v-scroll-to="`#services`" href="#services">Services</a>
                <a v-scroll-to="`#contact-wave`" href="#contact">Contact</a>
            </div>
			<div class="backdrop" v-if="toggler" >
				<transition name="fade">
					<div  class="mobile-menu" v-on-clickaway="away">
						<div class="list-wrap">
							<a  v-scroll-to="`#home`">Home</a>
							<a  v-scroll-to="`#about`">About</a>
							<a  v-scroll-to="`#services`">Services</a>
							<a  v-scroll-to="`#contact-wave`">Contact</a>
						</div>
					</div>
				</transition>
			</div>
        </div>

        <div class="nav" v-else>
            <img class="logo" src="../assets/logo-blue@2x.png" alt="cue-logo-rgb" />
			<div class="burger" :class="{animate: toggler}" @click="toggleMenu"></div>
            <div class="list-wrap">
                <a class="is-blue" v-scroll-to="`#home`">Home</a>
                <a class="is-blue" v-scroll-to="`#about`">About</a>
                <a class="is-blue" v-scroll-to="`#services`">Services</a>
                <a class="is-blue" v-scroll-to="`#contact-wave`">Contact</a>
            </div>
			<div class="backdrop" v-if="toggler" >
				<div  class="mobile-menu" v-on-clickaway="away">
					<div class="list-wrap">
						<a  v-scroll-to="`#home`">Home</a>
						<a  v-scroll-to="`#about`">About</a>
						<a  v-scroll-to="`#services`">Services</a>
						<a  v-scroll-to="`#contact-wave`">Contact</a>
					</div>
				</div>
			</div>
        </div>

    </transition>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
	mixins: [ clickaway ],
    data() {
        return {
			toggler: false,
            showFloat: false,
            isMobile: false
        };
    },
    methods: {
        scrollFloat() {
            if (!this.isMobile) {
                let observer = new IntersectionObserver(entries => {
                    let isIntersecting = entries[0].isIntersecting;
                    // let intersectionRatio = entries[0].intersectionRatio;
                    // console.log(entries);

                    this.showFloat = false;

                    if (isIntersecting) {
                        this.showFloat = false;
                        // console.log(this.showFloat);
                    } else {
                        this.showFloat = true;
                    }
                });
                observer.observe(document.querySelector("#contact-wave"));
            }
        },
		toggleMenu(){
			this.toggler = !this.toggler;
		},
		away(){
			// console.log('click away')
			this.toggler = false;
		}
    },
    mounted() {
        // page load calls
        this.scrollFloat();
        // this.$store.dispatch('updateCategories');
        // this.getRelatedPosts();

        if (window.innerWidth <= 768) {
            this.isMobile = true;
        }
    }
};
</script>
